import React from 'react';
import './ActiveFilterDisplay.css';

const ActiveFilterDisplay = ({ activeFilter, onClear, disabled }) => {
  if (!activeFilter) {
    return null;
  }

  const handleClearClick = () => {
    if (onClear && !disabled) {
      onClear();
    }
  };

  return (
    <div className="active-filter-display">
      <div className="active-filter-content">
        <span className="active-filter-label">Active filter:</span>
        <span className="active-filter-value">{activeFilter.displayLabel}</span>
      </div>
      <button
        className="clear-filter-button"
        onClick={handleClearClick}
        disabled={disabled}
        aria-label={`Clear active filter: ${activeFilter.displayLabel}`}
        type="button"
      >
        Clear
      </button>
    </div>
  );
};

export default ActiveFilterDisplay;